import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { editInput } from './editInput';

export const mergeAssetIntoPrefab = (
    prefabInput: GiftJson.Input<any>,
    userInput: GiftJson.Input<any>
): GiftJson.Input<any> => {

    const fromPrefab = prefabInput.value;
    const fromUser = userInput.value;

    return editInput(prefabInput, {
        assetUrl: fromUser.assetUrl || fromPrefab.assetUrl
    });
};